<template>
  <div class="flex gap-4 items-center max-w-xs w-full">
    <div class="profile-container">
      <img
        src="../mocks/gugulima.png"
        alt="Foto sorridente do embaixador."
        class="profile-image rounded-full"
      />
    </div>
    <div class="flex flex-col gap-1">
      <transition name="fade">
        <h1
          key="greeting"
          class="font-poppins text-base font-medium leading-6 tracking-wide text-gray-800"
        >
          {{ greeting }} BB!
        </h1>
      </transition>
      <p
        class="font-inter text-xs font-medium leading-4 tracking-tighter text-gray-600"
      >
        Confira abaixo o desempenho das equipes
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GoodMorningBaby',
  data() {
    return {
      currentHour: new Date().getHours(),
    };
  },
  computed: {
    greeting() {
      const hour = this.currentHour;
      const isMorning = hour >= 6 && hour < 12;
      const isAfternoon = hour >= 12 && hour < 18;

      if (isMorning) return 'Bom dia';
      if (isAfternoon) return 'Boa tarde';
      return 'Boa noite';
    },
  },
  mounted() {
    this.updateTime();
    this.timer = setInterval(this.updateTime, 60000);
  },
  methods: {
    updateTime() {
      this.currentHour = new Date().getHours();
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500&family=Inter:wght@500&display=swap');

.profile-container {
  width: 3.25rem; /* 52px */
  height: 3.25rem; /* 52px */
  border-radius: 9999px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.profile-image {
  width: 100%;
  height: auto;
  display: block;
}
.font-poppins {
  font-family: 'Poppins', sans-serif;
}
.font-inter {
  font-family: 'Inter', sans-serif;
}
.text-gray-600 {
  color: #6d6d6d;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
